<script setup lang="ts">
const { t } = useI18n()
const { create } = useNotification()

const uploadedSound = ref(null)

const upload = (event) => {
  if (event.target.files.length > 0) {
    uploadedSound.value = event.target.files[0]
    const type = uploadedSound.value?.type
    if (!['audio/mp3', 'audio/mpeg'].includes(type)) {
      create('error', { text: t('ui.soundUploader.error'), timeout: 2000 })

      uploadedSound.value = null
      return
    }

    const audioUrl = URL.createObjectURL(uploadedSound.value)
    create('success', { text: t('ui.soundRecorder.success'), timeout: 2000 })

    emit('onUpdate', audioUrl, uploadedSound.value)
  }
}
const emit = defineEmits<{ (e: 'onUpdate', url: string, audioBlob: Blob): void }>()
</script>

<template>
  <div class="relative h-full rounded-md border-2 border-dashed border-input">
    <input
      id="file"
      name="file"
      type="file"
      accept=".mp3,audio/mpeg3"
      class="relative z-10 block h-full w-full cursor-pointer px-10 py-24 opacity-0"
      @change="upload"
    />
    <div class="absolute left-0 right-0 top-0 m-auto h-full py-12 text-center">
      <h4 class="mx-auto hidden w-3/4 font-medium text-foreground sm:block">
        {{ t('ui.soundUploader.drag') }}
      </h4>
      <Button variant="outline" class="mb-2 mt-8">
        {{ t('ui.soundUploader.select') }}
      </Button>

      <p class="text-xs text-muted-foreground">
        {{ t('ui.soundUploader.constraints') }}
      </p>
    </div>
  </div>
</template>
